export const DATE_FORMAT = 'DD.MM';
export const DATE_YEAR_FORMAT = 'DD.MM.YYYY';
export const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';
